/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.85"
        height="18.85"
        viewBox="0 0 18.85 18.85"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.47 0a9.42 9.42 0 1 0 9.38 9.42A9.43 9.43 0 0 0 9.47 0Zm0 17.85a8.42 8.42 0 1 1 8.38-8.43 8.43 8.43 0 0 1-8.38 8.43Zm-.5-13.38h1v6.73h-1Zm.53 9.8a.84.84 0 0 0 .84-.83.85.85 0 0 0-.84-.84.84.84 0 0 0-.83.84.83.83 0 0 0 .83.83Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithExclamationPointIcon';

export default Icon;
